const NAME = "BENEFITS_FOR_PLANS";

export default NAME;
